import { h } from 'preact';
import React, {Component} from 'react';

import { TextSettings } from './TextSettings';
import './Text.css';

export class Text extends Component {
  componentDidMount = () => {
    this.nv.addEventListener('click', this.handleClick)
  }
  componentWillUnmount = () => {
    this.nv.removeEventListener('click', this.handleClick)
  }
  handleClick = (e) => {
    if (e.target.tagName === 'A' && e.target.href.includes('$$$$:')) {
      e.preventDefault();
      const choiceOptions = this.props.component.settings.choice_options || [];
      const optionId = e.target.href.split('$$$$:')[1];

      const option = choiceOptions.find(o => o.data.button_text === optionId);
      if (option && option.data.button_text) this.props.makeChoice(option.data.button_text);
    }
  }
  render() {
    const Settings = new TextSettings(this.props.component.settings);
    const styles = { 
      ...Settings.padding, 
      ...Settings.margin,
      ...Settings.border,
      ...Settings.font,
    };

    styles.textAlign = Settings.align;
    /* WIDTH & HEIGHT */
    const { paddingLeft, paddingRight } = Settings.padding; 
    const { marginLeft, marginRight } = Settings.margin; 
    styles.width = Settings.width.type === 'auto' ? 'auto' : Settings.width.value + Settings.width.type;
    if ( Settings.width.type === '%' ) {
      const adjustment = paddingLeft + paddingRight + marginLeft + marginRight;
      styles.width = `calc(${Settings.width.value}% - ${isNaN(adjustment) ? 0 : adjustment}px`
    }

    /* MANAGE LINK STYLING */
    const linkStyle = `color:${Settings.link.color};text-decoration:${Settings.link.textDecoration};font-weight: ${Settings.link.fontWeight};`;
    const hoverStyle = `onmouseover="this.style='color:${Settings.hover.color};text-decoration:${Settings.hover.textDecoration};font-weight: ${Settings.hover.fontWeight};'"`;
    const outStyle = `onmouseout="this.style=\'${linkStyle}\'"`;
    const textHTML = Settings.text.replace(/<a href/g, `<a style="${linkStyle}" ${hoverStyle} ${outStyle} href`);

    /* DEV MODE ONLY */
    let devActions = {}, selected = false, path = JSON.stringify(this.props.path);
    if (this.props.dev) {
      devActions = {...this.props.dev.hover };
      selected = this.props.dev.current === path;
    }

    const className = 'message-component text no-children';
    return (
      <p 
        className={selected ? className + ' on-active' : className} 
        path={path} 
        style={styles} 
        ref={element => { 
          this.nv = element;
          if (element && Settings.font.size) element.style.setProperty('font-size', Settings.font.size+'px', 'important'); 
        }}
        {...devActions} 
        dangerouslySetInnerHTML={{__html: textHTML }} />
    );
  }
}